import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, Users, MapPin } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const VenueDetailPage = () => {
  const { venueId } = useParams();
  const navigate = useNavigate();
  const [venue, setVenue] = useState(null);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    fetchVenueDetails();
  }, [venueId]);

  const fetchVenueDetails = async () => {
    try {
      const hotspotsResponse = await axios.get(`${API}/hotspots`);
      const foundVenue = hotspotsResponse.data.find(h => h.id === venueId);
      setVenue(foundVenue);

      const usersResponse = await axios.get(`${API}/hotspots/${venueId}/users`);
      setUsers(usersResponse.data);
    } catch (error) {
      console.error('Error fetching venue details:', error);
    }
  };

  if (!venue) return <div style={{ padding: '20px', color: '#E6D7C3' }}>Loading...</div>;

  return (
    <div>
      <div className="page-header" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <button onClick={() => navigate('/discover')} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#D7B56D', padding: '8px' }}>
          <ArrowLeft size={24} />
        </button>
        <div>
          <h1 className="page-title" style={{ fontFamily: 'Playfair Display, serif' }}>{venue.name}</h1>
          <p className="page-subtitle" style={{ textTransform: 'capitalize' }}>{venue.category}</p>
        </div>
      </div>

      <div style={{ padding: '16px' }}>
        <div style={{ display: 'flex', gap: '12px', marginBottom: '28px' }}>
          <div style={{ flex: 1, background: 'rgba(215, 181, 109, 0.15)', borderRadius: '16px', padding: '20px', textAlign: 'center', border: '1px solid #A57C33', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)' }}>
            <Users size={28} style={{ margin: '0 auto 10px', color: '#D7B56D' }} />
            <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#E6D7C3', marginBottom: '4px' }}>{venue.male_count}</div>
            <div style={{ fontSize: '13px', color: '#A57C33', fontWeight: '500' }}>Men Present</div>
          </div>
          <div style={{ flex: 1, background: 'rgba(106, 31, 40, 0.15)', borderRadius: '16px', padding: '20px', textAlign: 'center', border: '1px solid #6A1F28', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)' }}>
            <Users size={28} style={{ margin: '0 auto 10px', color: '#6A1F28' }} />
            <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#E6D7C3', marginBottom: '4px' }}>{venue.female_count}</div>
            <div style={{ fontSize: '13px', color: '#6A1F28', fontWeight: '500' }}>Women Present</div>
          </div>
        </div>

        <h3 style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '18px', color: '#D7B56D', fontFamily: 'Playfair Display, serif' }}>People Here Now</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '12px' }}>
          {users.map((user) => (
            <div
              key={user.id}
              onClick={() => navigate(`/user/${user.id}`)}
              style={{
                background: 'rgba(230, 215, 195, 0.05)',
                borderRadius: '16px',
                padding: '16px',
                border: '1px solid rgba(165, 124, 51, 0.4)',
                cursor: 'pointer',
                textAlign: 'center',
                transition: 'all 0.3s',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)'
              }}
              data-testid={`user-${user.id}`}
            >
              <img
                src={user.photo}
                alt={user.name}
                style={{ width: '90px', height: '90px', borderRadius: '50%', marginBottom: '12px', objectFit: 'cover', border: '2px solid #A57C33' }}
              />
              <div style={{ fontWeight: 'bold', fontSize: '15px', color: '#E6D7C3', marginBottom: '6px' }}>{user.name}, {user.age}</div>
              <div style={{ fontSize: '11px', color: '#D7B56D', fontWeight: '500' }}>Elite • Verified</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default VenueDetailPage;